import React from 'react';
import './../../css/style.css';
import axios from './../../../axios';
import Moment from "moment";
import FileListComponent from '../../../components/FundFiles/index.js';
import { handleNav, getFundEndDate } from '../../../util/index.js';

export default class GeqFund extends React.Component {
  constructor(props) {
    super(props);
    document.title = '中银国际英国保诚资产管理有限公司';
    this.params = {};
    this.state = {
      // 改为存储原始数据，而不是JSX
      downloads: [],      // 下载数据
      fundFiles: [],      // 基金文件数据
      fundNotices: [],    // 基金公告数据
      fundvaluelist: [],
      performanceTime: [],
      performanceValue: [],
      saleOrgs: [],       // 销售机构数据
      cumulativeData: [], // 累积表现数据
      cumulativeEndDate: '' // 累积表现数据截至日期
    };

    this.requestListTest();
    this.requestListPerformance();
    this.requestSaleOrg();
    this.requestCalcIncome();
    this.requestCumulativeEndDate();
  }

  requestCumulativeEndDate = async () => {
    const endDate = await getFundEndDate('968022');
    this.setState({ cumulativeEndDate: endDate });
  }

  // 请求销售机构数据
  requestSaleOrg = () => {
    axios.ajaxAESETF({
      url: '/aresoft-api/api/fundinfo/getFundInfoAgencyRelation',
      data: {
        params: {
          fundCode: '968022',
        }
      }
    }).then(res => {
      console.log(res, 'saleOrg')
      if (res.code === '0000' && res.data && res.data.length > 0) {
        // 按AGENT_CODE排序，确保顺序一致
        const sortedSaleOrgs = res.data.sort((a, b) => {
          return parseInt(a.AGENT_CODE) - parseInt(b.AGENT_CODE);
        });
        
        this.setState({
          saleOrgs: sortedSaleOrgs
        });
      }
    }).catch(error => {
      console.error('获取销售机构数据失败:', error);
    });
  }

  // 请求累积表现数据
  requestCalcIncome = () => {
    axios.ajaxAESETF({
      url: '/aresoft-api/api/fundinfo/getFundInfoCumulativeRelation',
      data: {
        params: {
          fundCode: '968022',
        }
      }
    }).then(res => {
      console.log(res, 'requestCalcIncome')
      if (res.code === '0000' && res.data && res.data.length > 0) {
        // 按CUMULATIVE_CODE排序，确保顺序一致
        const sortedCumulativeData = res.data.sort((a, b) => {
          return parseInt(a.CUMULATIVE_CODE) - parseInt(b.CUMULATIVE_CODE);
        });
        
        this.setState({
          cumulativeData: sortedCumulativeData
        });
      }
    }).catch(error => {
      console.error('获取累积表现数据失败:', error);
    });
  }

  requestListPerformance = () => {
    axios.ajaxAESETF({
      url: '/aresoft-api/api/getHKPerformanceList',
      data: {
        params: {
          fundCode: '968022',
          pageIndex: '1',
          pageSize: '100'
        }
      }
    }).then((res) => {
      this.setState({
        performanceTime: res.data && res.data.map((item, index) => (
          <td width="8%" key={`time-${index}`}>{item.PUBLISH_TIME}</td>
        )),
        performanceValue: res.data && res.data.map((item, index) => (
          <td width="8%" key={`value-${index}`}>{item.PUBLISH_PERFORMANCE}</td>
        ))
      });
    });
  }

  requestListTest = () => {
    // 获取最新份额净值
    axios.ajaxAESETF({
      url: '/aresoft-api/api/getLatestHKValue',
      data: {
        params: {
          fundcode: '968022',
        }
      }
    }).then((res) => {
      this.setState({
        fundvaluelist: handleNav(res.data)
      });
      // this.setState({
      //   fundvaluelist: res.data && res.data.map((item, index) => (
      //     <tr key={`nav-${index}`}>
      //       <td>{item.UPDATEDATE}</td>
      //       <td>人民币</td>
      //       <td colSpan="4">{item.NAV}</td>
      //     </tr>
      //   ))
      // });
    });

    // 获取文件列表
    axios.ajaxAESETF({
      url: '/aresoft-api/api/getHKFileList',
      data: {
        params: {
          fundcode: '968022',
          pageIndex: '1',
          pageSize: '1000',
          status: '1',
          publishdate: Moment().format('YYYY-MM-DD HH:mm:ss')
        }
      }
    }).then((res) => {
      // 将数据分类存储，不转换为JSX
      const downloads = res.data && res.data.filter(item => item.FILE_TYPE === '下载');
      const fundFiles = res.data && res.data.filter(item => item.FILE_TYPE === '基金文件');
      const fundNotices = res.data && res.data.filter(item => item.FILE_TYPE === '基金公告');

      this.setState({
        downloads,
        fundFiles,
        fundNotices
      });
    });
  }

  toTheTop = () => {
    document.documentElement.scrollTop = document.body.scrollTop = 0;
  }

  // 可选：处理文件点击事件的回调函数
  handleFileClick = (item, index, type) => {
    console.log(`点击了${type}中的文件:`, item.PUBLISH_NAME);
    // 这里可以添加统计代码、埋点等
  }

  // 可选：处理查看更多事件的回调函数
  handleViewMore = (type) => {
    console.log(`查看更多 ${type}`);
    // 这里可以添加统计代码
  }

  // 可选：处理收起事件的回调函数
  handleCollapse = (type) => {
    console.log(`收起 ${type}`);
    // 这里可以添加统计代码
  }

  // 渲染销售机构列表
  renderSaleOrgs = () => {
    const { saleOrgs } = this.state;
    
    if (!saleOrgs || saleOrgs.length === 0) {
      // 如果API没有返回数据，使用默认的销售机构列表
      return '上海基煜基金销售有限公司、中银基金管理有限公司直销柜台和奕丰基金销售有限公司';
    }
  
    if (saleOrgs.length === 1) {
      // 只有一个销售机构时，直接返回名称
      return saleOrgs[0].AGENT_NAME;
    } else if (saleOrgs.length === 2) {
      // 两个销售机构时，用"和"连接
      return `${saleOrgs[0].AGENT_NAME}和${saleOrgs[1].AGENT_NAME}`;
    } else {
      // 三个及以上销售机构时，前n-1个用顿号连接，最后一个用"和"连接
      const names = saleOrgs.map(org => org.AGENT_NAME);
      const lastItem = names.pop(); // 移除最后一个元素
      return `${names.join('、')}和${lastItem}`;
    }
  }

  // 渲染累积表现表格行
  renderCumulativeRow = () => {
    const { cumulativeData } = this.state;
    
    if (!cumulativeData || cumulativeData.length === 0) {
      // 如果没有数据，返回默认的空值
      return (
        <tr>
          <td>A类-人民币基金份额</td>
          <td>-</td>
          <td>-</td>
          <td>-</td>
          <td>-</td>
          <td>-</td>
        </tr>
      );
    }

    // 创建映射对象，便于按名称查找
    const dataMap = {};
    // 将接口返回的"成立至今"映射为"自起始日至今"
    cumulativeData.forEach(item => {
      const name = item.CUMULATIVE_NAME === '成立至今' ? '自起始日至今' : item.CUMULATIVE_NAME;
      dataMap[name] = item.FUND_PERCENT && Number(item.FUND_PERCENT).toFixed(2) + '%' || '-';
    });

    // 根据CUMULATIVE_NAME顺序渲染
    return (
      <tr>
        <td>A类-人民币基金份额</td>
        <td>{dataMap["年度至今"]}</td>
        <td>{dataMap["1年"]}</td>
        <td>{dataMap["3年"]}</td>
        <td>{dataMap["5年"]}</td>
        <td>{dataMap["自起始日至今"]}</td>
      </tr>
    );
  }

  render() {
    return (
      <div className="wrapper">
        <div className="main-container">
          <table>
            <tbody>
              <tr>
                <td width="12%">&nbsp;</td>
                <td className="main-content">
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td width="40%">内地代理人：</td>
                        <td width="60%">基金管理人：</td>
                      </tr>
                      <tr>
                        <td width="40%"><img src="./images/page1.png" alt="内地代理人" /></td>
                        <td width="60%"><img src="./images/page3.png" alt="基金管理人" /></td>
                      </tr>
                    </tbody>
                  </table>
                  
                  <table>
                    <tbody>
                      <tr>
                        <td className="display-banner">
                          <table cellSpacing="0" cellPadding="0">
                            <tbody>
                              <tr>
                                <td><img alt="" src="./images/banner-bg-fund-detail.jpg" width="320" height="89" /></td>
                                <td className="extend-bg"><img alt="" src="./images/banner-bg-repeat.jpg" width="1" height="89" /></td>
                                <td>
                                  <div className="banner-title">
                                    <img alt="" src="./images/banner-bg-r.jpg" width="280" height="89" />
                                    <h1 className="extendedWidth">中银香港环球股票基金<br />
                                      <font color="black">(A类 –人民币基金份额)</font>
                                    </h1>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div className="content">
                    <div className="greyBox">
                      <h2 className="marginT20">主要特色及风险揭示</h2>
                      <ul className="roundBullet marginT10">
                        <li>中银香港环球股票基金("本基金")为依据《香港互认基金管理规定》经中国证券监督管理委员会（"中国证监会"）注册后在内地公开销售的香港互认基金。但中国证监会对本基金的注册,并不表明其对本基金的投资价值、市场前景、风险和收益作出实质性判断、推荐或保证,也不表明投资于本基金没有风险。</li>
                        <li>本基金是根据香港法律成立并经香港证券及期货事务监察委员会（"香港证监会"）认可的基金。香港证监会的认可不等同于对本基金作出推介或认许,亦不是对本基金的商业利弊或其表现作出保证。更不代表本基金适合所有投资者,或认许本基金适合任何个别投资者或任何类别的投资者。本基金依照香港法律设立，其投资运作、信息披露等规范适用香港法律及香港证监会的相关规定。</li>
                        <li>投资涉及风险，基金管理人不保证本基金一定盈利，也不保证最低收益。本基金的过往业绩不预示其未来表现，基金管理人管理的其他基金的业绩并不构成本基金业绩表现的保证。</li>
                        <li>本基金可受市场和汇率波动及一切投资的固有风险所影响。本基金的份额净值及其收益（如有）可跌亦可升。在市场波动等因素的影响下，本基金投资有可能出现亏损或本基金净值有可能低于初始面值。投资者作出的投资可能并无回报及／或蒙受重大亏损。投资本基金前，需充分了解本基金的产品特性及投资风险，并承担本基金投资可能出现的亏损。</li>
                        <li>本基金存在一定的投资风险，包括：一般投资风险、货币风险、股票市场风险、集中风险、衍生工具风险、人民币货币及汇兑风险、非以基础货币计价的基金份额类别的相关风险、跨类别责任风险、潜在的利益冲突及投资于其他集体投资计划╱基金的风险。</li>
                        <li>内地投资者应特别关注以下所述本基金对于内地投资者的特殊风险以及本基金作为香港互认基金在内地销售的特有风险，包括: 境外投资风险、暂停内地销售的风险、取消基金互认、终止内地销售的风险、销售安排差异的风险、税收风险、汇率风险、适用境外法的相关风险、内地销售机构、内地代理人或内地登记结算机构的操作风险、技术风险及跨境数据传输和跨境资金结算交收的系统风险。</li>
                        <li>内地投资者持有的基金份额将由名义持有人（即，中银基金管理有限公司）代名持有并以名义持有人的名义登记为名义持有人。内地投资者及其所持有的基金份额并不会在基金登记机构的持有人名册上进行登记，而仅由名义持有人进行登记。内地投资者需通过名义持有人行使信托契约等基金法律文件规定的基金份额持有人权利及履行相应的基金份额持有人义务。</li>
                        <li>请投资者在进行投资决策前，认真阅读本基金的信托契约、招募说明书及产品资料概要等法律文件，了解本基金的具体情况。</li>
                      </ul>
                    </div>
                    
                    <h2 className="marginT20">投资目标</h2>
                    <p>
                      本基金是一只股票型基金，旨在通过主要（最少以其非现金资产的百分之七十）投资于主要环球证券市场，包括（但不限于）美国、英国、德国、法国及日本，以求实现长期资本增长。本基金投资于股票及与股票相关的证券，包括认股权证及可转换证券。本基金的投资组合于各国家及地区之间的分配可能根据基金管理人的酌情权及对现时和预期的市场状况看法而改变，因此，本基金的投资组合可能集中于某（些）国家或地区。本基金可最多将其资产的百分之三十投资于香港证监会认可的集体投资计划（包括由基金管理人管理的集体投资计划）。本基金可(a)最多将其资产净值的百分之二十投资于A股((i)通过沪港通及／或深港通直接投资于A股；及／或(ii)通过投资于:(A)在香港联合交易所有限公司上市的交易所买卖基金("ETF")(包括由基金管理人管理的ETF)、(B)在中国内地的证券交易所上市的符合资格的ETF(通过沪港通及／或深港通)及／或(C)香港证监会认可的集体投资计划(包括由基金管理人管理的集体投资计划)间接投资于A股)；及／或(b)最多将其资产净值的百分之五投资于在中国内地的证券交易所上市的B股。本基金于A股及B股的总投资额将不超过其资产净值的百分之二十。本基金亦可投资于其他股票相关证券，例如是ADR（美国存托凭证）及GDR（全球存托凭证），其可在各个证券交易所上市。本基金可将其部分资产用于期货合约、期权或远期货币交易，以进行有效率的投资组合管理及对冲汇率风险。在适当时可考虑持有现金和定息证券。本基金将不会进行任何证券借贷活动。
                    </p>
                    
                    <h2 className="marginT30 greyLine">资料概览</h2>
                    <table className="alternative-bg2 records">
                      <tbody>
                        <tr>
                          <td className="greytxt width20">基金代码</td>
                          <td colSpan="5">968022</td>
                        </tr>
                        <tr className="odd">
                          <td className="greytxt">基金管理人</td>
                          <td colSpan="5">中银国际英国保诚资产管理有限公司</td>
                        </tr>
                        <tr>
                          <td className="greytxt">内地代理人</td>
                          <td colSpan="5">中银基金管理有限公司</td>
                        </tr>
                        <tr className="odd">
                          <td className="greytxt">基金类型</td>
                          <td colSpan="5">常规股票型</td>
                        </tr>
                        <tr>
                          <td className="greytxt">起始日期</td>
                          <td colSpan="5">
                            本基金：2002年7月12日<br />
                            A类 –人民币基金份额：2015年6月29日
                          </td>
                        </tr>
                        <tr className="odd">
                          <td className="greytxt">交易频率</td>
                          <td colSpan="5">每工作日#</td>
                        </tr>
                        <tr>
                          <td className="greytxt">在内地销售的基金份额类别的计价货币</td>
                          <td colSpan="5">人民币</td>
                        </tr>
                        <tr  className="odd">
                          <td className="greytxt">收益分配政策</td>
                          <td colSpan="5">基金管理人不拟就本基金做出任何收益分配，本基金获得的任何收益将用于再投资于本基金</td>
                        </tr>
                        <tr>
                          <td className="greytxt">申购费*</td>
                          <td colSpan="5">
                            <div>3%</div>
                            <div>本基金的申购费由申购基金份额的投资者承担，不列入基金财产，主要用于本基金的市场推广、销售等各项费用。</div>
                          </td>
                        </tr>
                        <tr  className="odd">
                          <td className="greytxt">赎回费*</td>
                          <td colSpan="5">无</td>
                        </tr>
                        <tr>
                          <td className="greytxt">管理费*</td>
                          <td colSpan="5">目前为基金资产净值的1.5%/年，最高为基金资产净值的1.5%/年**</td>
                        </tr>
                        <tr  className="odd">
                          <td className="greytxt">受托人费用*</td>
                          <td colSpan="5">
                            首个2,500万美元的0.125%；第二个2,500万美元的0.10%；余额的0.0875%；<br />
                            须缴付最低月费2,500美元，最高为1%**
                          </td>
                        </tr>
                        <tr>
                          <td className="greytxt">业绩表现费</td>
                          <td colSpan="5">无</td>
                        </tr>
                        <tr  className="odd">
                          <td className="greytxt">风险等级 <sup>◆</sup></td>
                          <td colSpan="5">【R4 中高风险】</td>
                        </tr>
                      </tbody>
                    </table>
                    
                    <div className="table-note">
                      <p>
                        #本基金内地销售的工作日是指内地销售机构接受办理内地投资者申购、赎回、转换等业务的日期, 具体为上海证券交易所和深圳证券交易所同时开放交易的香港交易日，或基金管理人经受托人批准后另行决定的本基金在内地销售的日期。<br />
                        * 有关详情，请参阅本基金的信托契约、招募说明书及产品资料概要等法律文件。<br />
                        **投资者应注意，该等费用可在向内地投资者至少提前三个月进行公告后提高费率（但最多不超过最高费率）。有关详情，请参阅本基金的信托契约、招募说明书及产品资料概要等法律文件。<br />
                      </p>
                      <p><b><sup>◆</sup>此网页所显示的风险等级由内地代理人进行评级及提供，基金管理人未对该等资料进行独立核证。相关风险评级结果是内地代理人根据投资者适当性法律法规对本基金进行风险评价的结果，未必与基金管理人所提供的风险等级资料一致。基金管理人并不就本处风险等级资料的任何错误、遗漏、不准确、不充分或未及时更新承担任何责任。相关风险等级供投资者参考，内地销售机构亦将根据法规要求对投资者类别、风险承受能力和本基金的风险等级进行划分，并提出适当性匹配意见，请投资者根据自身风险承受能力购买相匹配的风险等级产品。投资者不应只根据本处风险等级资料而作出任何投资决定。若对上述所提供的风险等级资料有任何疑问，请咨询独立财务及专业人士的意见。</b></p>
                    </div>

                    <h2>最新份额净值</h2>
                    <table>
                      <tbody>
                        <tr>
                          <td width="20%">日期</td>
                          <td width="20%">货币</td>
                          <td colSpan="4">份额净值</td>
                        </tr>
                        {this.state.fundvaluelist}
                      </tbody>
                    </table>
                    
                    <div className="table-note">
                      <p>
                        基金份额净值以"未知价原则" (Forward-Pricing Basis) 显示。<br />
                        <b>投资涉及风险。基金份额净值只供参考，并可能在没有作出通知的情况下作出变更。基金份额净值及其收益分配（如有）可跌亦可升。</b><br />
                      </p>
                    </div>

                    {/* 新增累积表现部分 */}
                    {/* <h2>累积表现 [收益会滚存再作投资] - 数据截至{Moment(new Date()).format('YYYY年MM月DD日')}^</h2> */}
                    <h2>累积表现 [收益会滚存再作投资] - 数据截至{this.state.cumulativeEndDate || '2025年10月31日'}^</h2>
                    <table className="records headingAlignCenter alternative-bg">
                      <tbody>
                        <tr>
                          <td width="20%"></td>
                          <td width="16%">年度至今<sup>Ω</sup></td>
                          <td width="16%">1年</td>
                          <td width="16%">3年</td>
                          <td width="16%">5年</td>
                          <td width="16%">自起始日至今</td>
                        </tr>
                        {this.renderCumulativeRow()}
                      </tbody>
                    </table>
                    
                    <div className="table-note">
                      <p><sup>Ω</sup>只会于年度至今表现数据足够显示超过6个月的业绩表现时，才会展示相关数据。</p>
                    </div>

                    <h2>基金年度的过往表现^</h2>
                    <table className="records headingAlignCenter alternative-bg" id="past_authorisedrmb">
                      <tbody>
                        <tr>
                          <td width="15%"></td>
                          {this.state.performanceTime}
                        </tr>
                        <tr>
                          <td>A类-人民币基金份额</td>
                          {this.state.performanceValue}
                        </tr>
                      </tbody>
                    </table>
                    
                    <div className="table-note">
                      <p>
                        <b>^资料来源: 中银国际英国保诚资产管理有限公司。投资涉及风险，过往表现的资料并不代表未来的表现。投资者未必能取回全部投资本金。</b><br />
                        基金表现以公历年年末的基金份额资产净值作为比较基准，分配会滚存再作投资，并反映于基金份额资产净值中。<br />
                        上述数字显示有关A类 –人民币基金份额历年来价值的升跌幅度。基金表现以人民币计算，当中包括基金的经常性开支，但不包括投资者或须缴付的申购费和赎回费。如年内没有显示有关表现资料，即代表该年未有足够数据提供用作表现资料。<br />
                        <br />
                      </p>
                      <p>
                        基金起始日：2002年7月12日<br />A类 –人民币基金份额起始日：2015年6月29日
                      </p>
                    </div>

                    {/* 使用FileListComponent组件 */}
                    
                    {/* 下载部分 */}
                    <FileListComponent
                      items={this.state.downloads}
                      title="下载"
                      type="downloads"
                      showDate={false}  // 下载不显示日期
                      defaultCount={5}
                      onItemClick={this.handleFileClick}
                      onViewMore={this.handleViewMore}
                      onCollapse={this.handleCollapse}
                    />

                    {/* 基金文件部分 */}
                    <FileListComponent
                      items={this.state.fundFiles}
                      title="基金文件"
                      type="files"
                      defaultCount={5}
                      dateFormat="slice"
                      onItemClick={this.handleFileClick}
                      onViewMore={this.handleViewMore}
                      onCollapse={this.handleCollapse}
                    />

                    {/* 基金公告部分 */}
                    <FileListComponent
                      items={this.state.fundNotices}
                      title="基金公告"
                      type="notices"
                      defaultCount={5}
                      dateFormat="slice"
                      onItemClick={this.handleFileClick}
                      onViewMore={this.handleViewMore}
                      onCollapse={this.handleCollapse}
                    />

                    <h2 className="marginT20">重要事项</h2>
                    <div>
                      <div className="imptNote233">
                        {/* 修改这里：销售机构动态渲染 */}
                        <p>投资者应当通过本基金的内地代理人和/或基金管理人或内地代理人委托的其他具有基金销售业务资格的销售机构申购和赎回本基金。现时，本基金的内地销售机构包括{this.renderSaleOrgs()}。基金管理人或内地代理人可不时变更或增减内地销售机构，并予以公示。</p>
                        <p><b>投资者在作出投资前，应先考虑本身之投资目标、可承受的风险程度及其他因素，并适当地寻求独立的财务及专业意见。有关基金详情（包括风险因素、收费及基金资料），请参阅本基金的信托契约、招募说明书及产品资料概要等法律文件。</b></p>
                        <p>投资者须注意，中国银行(香港)有限公司并不是本基金的基金管理人，只是本基金的基金保荐人，而中银国际英国保诚资产管理有限公司则为基金管理人。本基金的内地代理人为中银基金管理有限公司。内地代理人接受基金管理人的委托，并不表明内地代理人对代理本基金的价值和收益作出实质性判断或保证，也不表明投资于本基金没有风险。内地代理人对本基金的财政稳健状况或任何在本基金招募说明书中作出的声明或发表的意见，不承担任何责任。</p>
                        <p>本网站所载的内容由中银国际英国保诚资产管理有限公司制作，并由中银基金管理有限公司刊发，并未经中国证监会及香港证监会审阅。</p>
                      </div>
                    </div>
                    
                    <p className="tdR marginT20">
                      <img alt="回到顶部" src="./images/cn/btn-backToTop.jpg" onClick={this.toTheTop} />
                    </p>
                  </div>
                </td>
                <td width="12%">&nbsp;</td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <p className="footer">
          <table>
            <tbody>
              <tr>
                <td className="copyright">
                  <div>&copy; 中银基金管理有限公司及中银国际英国保诚资产管理有限公司。版权所有。</div>
                </td>
                <td width="50%">
                  <table>
                    <tbody>
                      <tr height="10px">
                        <td width="50%"><font size="2">内地代理人：</font></td>
                        <td width="50%"><font size="2">基金管理人：</font></td>
                      </tr>
                      <tr>
                        <td width="50%"><img src="./images/page1.png" alt="内地代理人" /></td>
                        <td width="50%"><img src="./images/page3.png" alt="基金管理人" /></td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </p>
      </div>
    );
  }
}